import { render, staticRenderFns } from "./FileSystemSettings.vue?vue&type=template&id=f518f06c"
import script from "./FileSystemSettings.vue?vue&type=script&lang=js"
export * from "./FileSystemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports